export default {
  methods: {
    tweet(name){
      //シェアする画面を設定
      var shareURL = `https://twitter.com/intent/tweet?text=${name} - NerzExpress ${location.href} @nerz_jp `
      //シェア用の画面へ移行
      location.href = shareURL
    }
  }
}
